export default __webpack_public_path__ + "static/media/Personaje-Banner-2.24b33984.png";